import { useSearchParams } from 'react-router-dom'

interface UsePaginationProps {
  defaultPage?: number
  defaultLimit?: number
}

export function usePagination({ defaultPage = 1, defaultLimit = 20 }: UsePaginationProps = {}) {
  const [searchParams, setSearchParams] = useSearchParams()

  const page = Number(searchParams.get('page')) || defaultPage
  const limit = Number(searchParams.get('limit')) || defaultLimit

  const setPage = (newPage: number) => {
    setSearchParams(prev => {
      prev.set('page', String(newPage))
      return prev
    })
  }

  const setLimit = (newLimit: number) => {
    setSearchParams(prev => {
      prev.set('limit', String(newLimit))
      prev.set('page', '1') // Reset to page 1 on limit change
      return prev
    })
  }

  return {
    page,
    limit,
    setPage,
    setLimit,
  }
}
